import { useMemo } from "react";
import Logo from "@/assets/images/logo.png";
import { bookingRoutes } from "@/components/hooks/use-booking-route";
import { usePathname } from "@/components/hooks/use-pathname";
import { useSegments } from "@/components/hooks/use-segments";
import { IfElse } from "@/components/shared/if-else";
import { useRoute } from "@/components/shared/router";
import { Image, View } from "@/components/ui";

import { DesktopNavButton } from "../desktop-nav-button";
import { UserDropdown } from "../user-dropdown";

export enum HeaderLinkEnum {
  Home = "Home",
  Visits = "Visits",
  Invoices = "Invoices",
  Rewards = "Rewards",
}

const HeaderLinks = [
  { title: HeaderLinkEnum.Home, href: "" },
  { title: HeaderLinkEnum.Visits, href: "/visits" },
  { title: HeaderLinkEnum.Invoices, href: "profile/invoices" },
  { title: HeaderLinkEnum.Rewards, href: "/rewards" },
];

export const NavbarHeader = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const segments = useSegments();
  const activeLink = useMemo(() => {
    if (segments.length === 0) return HeaderLinkEnum.Home;
    if (segments[0] === "visits") return HeaderLinkEnum.Visits;
    if (segments[1] === "invoices") return HeaderLinkEnum.Invoices;
    if (segments[0] === "rewards") return HeaderLinkEnum.Rewards;
  }, [segments]);
  const path = usePathname();

  const showNavigation = useMemo(() => {
    return !Object.values(bookingRoutes)
      .flat()
      .filter((route) => !route.includes("service-detail") && !route.includes("complete-booking"))
      .includes(path);
  }, [segments]);

  const { push } = useRoute();

  return (
    <View className="bg-brand-static pointer-events-auto sticky top-0 z-50 flex w-full flex-col">
      <View className="container flex h-[64px] w-full items-center justify-between px-4 lg:px-0">
        <View
          className="flex cursor-pointer items-center justify-center"
          onClick={() => push({ pageKey: "homepage" })}
        >
          <Image src={Logo} alt="Luce" className="h-7" />
        </View>

        <IfElse if={showNavigation}>
          <>
            <View className="md:hidden">
              {/* web only (this header is the web navbar's); the hamburger CSS is made for a button */}
              <button
                type="button"
                aria-label={open ? "Close menu" : "Open menu"}
                aria-expanded={open}
                className={open ? "hamburger hamburger--slider is-active" : "hamburger"}
                onClick={() => setOpen(!open)}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            </View>

            <View className="hidden gap-4 md:flex">
              <View className="hidden grow flex-row items-center justify-around gap-1 text-white md:flex">
                {HeaderLinks.map((link) => {
                  return (
                    <DesktopNavButton
                      key={link.title}
                      title={link.title}
                      href={link.href}
                      active={link.title === activeLink}
                    />
                  );
                })}
              </View>
              <UserDropdown />
            </View>
          </>
        </IfElse>
      </View>
    </View>
  );
};
